
import './Dashboard.module.css';
import QueryString from "query-string";
import React from 'react';

class SpotifyAuthenticationView extends React.Component {

  SpotifyAuthenticationView() {
    return (
      <div>ayaya</div>
    );
  }

  componentDidMount(){
    const requestOptions = {
      method: 'POST',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };
  
    console.log(localStorage.getItem("user_token"));
    console.log(window.location.pathname);
  
    const params = QueryString.parse(window.location.href.split("?")[1]);

    console.log(params);
  
    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'user/spotify?code=' + params.code, requestOptions)
        .then(response => response.json())
        .then(data => {

          window.location.href = `/dashboard/account`; 
        });
    }


  render(){
    return <div>aaaaaa</div>;
  }

}





export default SpotifyAuthenticationView;
